import React from 'react';
import { Handle } from 'reactflow';

const CBCGroup = ({ data = {} }) => {
  const { 
    onAprobarTodasCBC, 
    cbcExpanded, 
    onToggleCbcExpanded,
    materiasAprobadas = 0,
    materiasCursando = 0,
    totalMaterias = 6
  } = data;

  const handleToggleExpanded = (e) => {
    e.stopPropagation();
    if (onToggleCbcExpanded && typeof onToggleCbcExpanded === 'function') {
      onToggleCbcExpanded();
    }
  };

  const handleAprobarClick = (e) => {
    e.stopPropagation();
    if (onAprobarTodasCBC && typeof onAprobarTodasCBC === 'function') {
      onAprobarTodasCBC();
    }
  };

  const handleTouchStart = (e) => {
    // Prevenir el scroll cuando se hace tap en el elemento
    e.preventDefault();
  };

  const handleTouchEnd = (e) => {
    e.preventDefault();
    handleToggleExpanded(e);
  };

  const getProgressColor = () => {
    const progress = materiasAprobadas / totalMaterias;
    if (progress === 1) return 'var(--success-color)';
    if (progress >= 0.5) return 'var(--warning-color)';
    return 'var(--error-color)';
  };

  return (
    <div 
      className="cbc-group" 
      onClick={handleToggleExpanded}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      style={{
        cursor: 'pointer',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        WebkitTouchCallout: 'none',
        position: 'relative',
        minWidth: '200px',
        padding: '12px',
        border: `2px solid ${getProgressColor()}`,
        borderRadius: '8px',
        backgroundColor: 'var(--bg-secondary)',
        boxShadow: 'var(--shadow-small)',
        transition: 'all 0.3s ease'
      }}
      title={cbcExpanded ? "Clic para colapsar CBC" : "Clic para expandir CBC"}
    >
      <Handle type="source" position="right" />
      
      <div style={{ textAlign: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '8px' }}>
          <h3 style={{ margin: 0, color: getProgressColor(), fontSize: '1.1em' }}>
            Ciclo Básico Común
          </h3>
          <span style={{ 
            fontSize: '1.2em',
            color: 'var(--text-primary)',
            transform: cbcExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease'
          }}>
            ▶
          </span>
        </div>
        
        <div style={{ marginBottom: '8px' }}>
          <div style={{ 
            fontSize: '0.85em', 
            color: 'var(--text-primary)',
            fontWeight: '500'
          }}>
            {materiasAprobadas}/{totalMaterias} aprobadas
            {materiasCursando > 0 && ` • ${materiasCursando} cursando`}
          </div>
          
          <div style={{
            width: '100%',
            height: '4px',
            backgroundColor: 'var(--bg-primary)',
            borderRadius: '2px',
            overflow: 'hidden',
            marginTop: '4px'
          }}>
            <div style={{
              width: `${(materiasAprobadas / totalMaterias) * 100}%`,
              height: '100%',
              backgroundColor: getProgressColor(),
              transition: 'width 0.3s ease'
            }} />
          </div>
        </div>

        {onAprobarTodasCBC && (
          <button
            onClick={handleAprobarClick}
            style={{
              padding: '4px 8px',
              fontSize: '0.75em',
              backgroundColor: 'var(--success-color)',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              marginTop: '4px'
            }}
            onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
            title="Aprobar todas las materias CBC como cursadas"
          >
            ✅ Aprobar CBC
          </button>
        )}

        {cbcExpanded && (
          <div style={{
            fontSize: '0.75em',
            color: 'var(--text-muted)',
            fontStyle: 'italic',
            marginTop: '4px'
          }}>
            Materias expandidas
          </div>
        )}
      </div>
      
      <Handle type="target" position="left" />
    </div>
  );
};

export default CBCGroup; 